/* import __COLOCATED_TEMPLATE__ from './zebra-printer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();